import { z } from "zod";
import { InspectionRescheduleReasonSchema } from "@remi/enums/inspection-reschedule-reason";
import { TaskType } from "@remi/enums/task-type";

export const FinalInspectionScheduledTaskAttemptSchema = z.object({
  type: z.literal(TaskType.FINAL_INSPECTION_SCHEDULED),
  reason: InspectionRescheduleReasonSchema,
  finalInspectionScheduledAt: z.coerce.date().nullable(),
});

export type FinalInspectionScheduledTaskAttempt = z.infer<typeof FinalInspectionScheduledTaskAttemptSchema>;
